import { render } from "./FormGroupCustom.vue?vue&type=template&id=1d25c96a&scoped=true"
import script from "./FormGroupCustom.vue?vue&type=script&lang=js"
export * from "./FormGroupCustom.vue?vue&type=script&lang=js"

import "./FormGroupCustom.vue?vue&type=style&index=0&id=1d25c96a&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d25c96a"]])

export default __exports__